/**
 * restaurantStyles — CSS for restaurant components inside the shadow DOM.
 * Reuses ecommerce CSS infrastructure. Adds restaurant-specific overrides.
 */
import { generateEcommerceCSS } from '../ecommerce/ecommerceStyles.js';

export function generateRestaurantCSS() {
  return generateEcommerceCSS() + `

/* ═══════════════════════════════════════
   RESTAURANT-SPECIFIC OVERRIDES
   ═══════════════════════════════════════ */

.ttp-restaurant-area {
  display: flex !important;
  flex-direction: column !important;
  width: 100%;
  flex: 1 1 0 !important;
  min-height: 0 !important;
  position: relative !important;
  overflow-x: hidden !important;
  overflow-y: hidden !important;
}

#voiceActiveState.ttp-menu-visible .desktop-voice-section {
  display: none !important;
}
#voiceActiveState.ttp-menu-visible .compact-voice-section {
  display: flex !important;
}
#voiceActiveState.ttp-menu-visible .desktop-conversation-panel {
  flex: 0 0 auto !important;
}
#voiceActiveState.ttp-menu-visible .conversation-history {
  display: none !important;
}
#voiceActiveState.ttp-menu-visible .live-transcript-collapsed {
  flex: 0 0 auto !important;
}

.ttp-product-tags {
  margin-top: 3px;
  line-height: 1.6;
}

.ttp-allergen-tag {
  display: inline-block;
  font-size: 9px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 4px;
  background: rgba(251,191,36,0.12);
  color: #fbbf24;
  margin-right: 3px;
  margin-bottom: 2px;
}

.ttp-dietary-tag {
  display: inline-block;
  font-size: 9px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 4px;
  background: rgba(52,211,153,0.12);
  color: #34d399;
  margin-right: 3px;
  margin-bottom: 2px;
}

.ttp-order-summary-inline {
  margin: 0 !important;
  margin-top: 10px !important;
}
`;
}
